var map = {
	"./aplicaciones.png": 802,
	"./caso1.png": 997,
	"./caso10.png": 19,
	"./caso11.png": 272,
	"./caso12.png": 89,
	"./caso13.png": 394,
	"./caso14.png": 5,
	"./caso2.png": 597,
	"./caso3.png": 478,
	"./caso4.png": 458,
	"./caso5.png": 419,
	"./caso6.png": 95,
	"./caso7.png": 275,
	"./caso8.png": 729,
	"./caso9.png": 804,
	"./directorio-telefonico.png": 485,
	"./disenador-grafico.png": 512,
	"./fondo.png": 229,
	"./menu.png": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;